<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <b-card class="text-center m-5">
                    <h1>404</h1>
                    <h2>This page could not be found!</h2>
                    <h3>We are sorry. But the page you are
                        looking for is not available.</h3>
                    <b-img height="600rem" src="https://s3.us-west-2.amazonaws.com/media.ooica.net/wp-content/uploads/2019/01/03214203/octopussm.jpg"></b-img>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Page404',
};
</script>
